import {
  VuexModule,
  Module,
  getModule,
  Mutation,
  Action,
} from "vuex-module-decorators";
import store from "@/store";

import { AccountingPoint } from "../../lib/AccountingPoint.type";
import router from "@/router";
import { AccountingPointsModule } from "./accountingpoints.module";

@Module({
  dynamic: true,
  store,
  name: "pointmod",
  preserveState: localStorage.getItem("vuex") !== null,
})
export class PointVuexModule extends VuexModule {
  loading: boolean = false;
  aPoint: AccountingPoint = new AccountingPoint();

  @Mutation
  public setLoading() {
    this.loading = false;
  }

  @Mutation
  public setaPoint(value: AccountingPoint) {
    this.aPoint = value;
  }

  @Action
  public selectPointAndRoute(value: number) {
    this.selectPoint(value);
    router.push({
      name: "point",
      params: {
        pointId: value.toString(),
      },
    });
  }

  @Action
  public selectPoint(pointId: number) {
    const point = AccountingPointsModule.pointList.find(
      c => c.account_point_rid === pointId,
    ) as AccountingPoint;
    this.setaPoint(point);
  }
}

export const PointModule = getModule(PointVuexModule);
